import { serverTimestamp } from "firebase/database";
import db_lib from 'xAppLib/libs/db_lib';
import API_service from 'xAppLib/providers/API_service'
import logger from 'xAppLib/libs/logger';
import { sort_med_scripts_for_wr, withUr } from "./utils";

const _FRDB_LOC = 'MedScripts';

const DEBUG = false

function owner() { return {uid:app.user.uid,name:app.user.name} }


export default class instcons_global_model_base extends db_lib {

    static get FRDB_LOC() { return _FRDB_LOC; }

    // region: deprecated, use equivalent methods from waiting_room_model
    static watch_approvals(onData, onError) {
        return this.watch_all_records(onData, {where_key: 'wr', where_val: 'app_scripts', ce: onError});
    }

    static watch_urgent_fu(onData, onError) {
        return this.watch_all_records(onData, {where_key: 'wr', where_val: 'urgent_fu', ce: onError });
    }

    static watch_need_review(onData, onError) {
        return this.watch_all_records(onData, {where_key: 'wr', where_val: 'need_review', ce: onError });
    }

    static watch_escript_review(onData, onError) {
        return this.watch_all_records(onData, {where_key: 'wr', where_val: 'escript_review', ce: onError });
    }

    static awaiting_gp_consult(onData, onError) {
        return this.watch_all_records(
            records => onData(sort_med_scripts_for_wr(records).map(withUr)),
            {where_key: 'wr', where_val: 'await_consult', ce: onError }
        );
    }

    static awaiting_urgent_fu(onData, onError) {
        return this.watch_all_records(
            records => onData(sort_med_scripts_for_wr(records).map(withUr)),
            {where_key: 'wr', where_val: 'urgent_fu', ce: onError }
        );
    }
    // endregion

    static async own(sid, own = true, extra) {
        try {
            const rev_tm = own ? Date.now() : null;
            const srv_tm = own ? serverTimestamp() : null;
            const getOwner = own ? owner() : null;
            await this.update_record(sid, {
                owner: getOwner,
                rev_tm,
                srv_tm,
                ...(extra && {extra})
            });
        } catch (error) {
            console.log("got error",error);
        }
        
    }


    static create_session({sid, test} = {}) {
        return API_service.load_data('instcons/create_session', {sid, test})
    }


    static async update_status(row, status, p) {
        const { sid } = row
        try {
            const data = {
                pending:true,
                owner:owner(),
                doc: app.user.claims.doc_id
            } 
            console.log("update_status", {sid, status, p})
            await this.update_record(
                sid,
                data,
                {add_hist: true}
            );
            const chgStat = () => API_service.load_data( 'chgStat', {sid, stat: status, doc: app.user.claims.doc_id, ...p} )
            let ret
            try {
                ret = await chgStat()
            } catch (error) {
                DEBUG && console.error(error)
                logger.report_error('ERROR in WR update_status', 'error', error);
                try {
                    ret = await chgStat()
                } catch (error) {
                    DEBUG && console.error(error)
                    logger.report_error('ERROR [TWICE] in WR update_status', 'error', error);
                    ret = error
                    this.update_record( sid,{
                        pending:null,
                        owner:null,
                        doc:null,
                        rev_tm: null
                    },{add_hist: true})
                }
            }
            return ret
           
        } catch (error) {
            console.log("got error updating status",error);
            logger.report_except(error,{sid,status,owner:owner()})
            return {res:'err',error}
        }
        
    }

    static watch_unlock_override(sid, onData) {
        return this.watch_record(`${sid}/presc_unlock`, onData);
    }	

}